import { formatDate } from "./common";

export const SUBSCRIPTION_STATUS_DATE_FORMAT = "dd MMM";
export const SUBSCRIPTION_RENEWAL_DATE_FORMAT = "dd/MM/yyyy";

export const formatSubscriptionStatusDate = (
  unixSeconds: number | null,
): string =>
  formatDate(
    unixSeconds ? parseInt(`${unixSeconds}000`) : undefined,
    SUBSCRIPTION_STATUS_DATE_FORMAT,
  );

export const formatMembershipRenewalLabel = (
  unixSeconds: number | null,
): string =>
  `Renewal on ${formatDate(
    unixSeconds ? parseInt(`${unixSeconds}000`) : undefined,
    SUBSCRIPTION_RENEWAL_DATE_FORMAT,
  )}`;
